(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-section"] && !Shopify.designMode) return;
  try {
    
  function openPage(link) {
    window.open(link, '_blank');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
    var tabButtons = document.getElementsByClassName('tab-button');
    var collectionItems = document.getElementsByClassName('collection-items');

    tabButtons[0].classList.add('active');
    collectionItems[0].classList.add('active');

    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].addEventListener('click', function() {

        var selectedCollection = this.getAttribute('data-collection');

        // Remove active class from all tab buttons
        for (var j = 0; j < tabButtons.length; j++) {
          tabButtons[j].classList.remove('active');
        }

        // Remove active class from all collection items
        for (var k = 0; k < collectionItems.length; k++) {
          collectionItems[k].classList.remove('active');
        }

        // Add active class to the selected tab button
        this.classList.add('active');

        // Add active class to the selected collection items
        var selectedCollectionItems = document.querySelector('.collection-items[data-collection="' + selectedCollection + '"]');
        selectedCollectionItems.classList.add('active');
      });
    }





  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-videos"] && !Shopify.designMode) return;
  try {
    
    document.getElementById('tickvid1').addEventListener('click', function() {
      var video = this;
      video.play();
      this.controls = true;
      this.addEventListener('ended', function() {
        video.controls = false;
      });

      console.log(this.parent)
  });

  document.getElementById('play-button1').addEventListener('click', function() {
    document.getElementById('tickvid1').play();
    document.getElementById('play-button1').style.display = 'none';
  });

   document.getElementById('tickvid4').addEventListener('click', function() {
      var video = this;
      video.play();
      this.controls = true;
      this.addEventListener('ended', function() {
        video.controls = false;
      });

      console.log(this.parent)
  });

  document.getElementById('play-button4').addEventListener('click', function() {
    document.getElementById('tickvid4').play();
    document.getElementById('play-button4').style.display = 'none';
  });

   document.getElementById('tickvid2').addEventListener('click', function() {
      var video = this;
      video.play();
      this.controls = true;
      this.addEventListener('ended', function() {
        video.controls = false;
      });

      console.log(this.parent)
  });

  document.getElementById('play-button2').addEventListener('click', function() {
    document.getElementById('tickvid2').play();
    document.getElementById('play-button2').style.display = 'none';
  });

   document.getElementById('tickvid3').addEventListener('click', function() {
      var video = this;
      video.play();
      this.controls = true;
      this.addEventListener('ended', function() {
        video.controls = false;
      });

      console.log(this.parent)
  });

  document.getElementById('play-button3').addEventListener('click', function() {
    document.getElementById('tickvid3').play();
    document.getElementById('play-button3').style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();
})();
